import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';

import LandingNew from '../Modules/LandingPageNew/LandingPageScreen';
import TnCScreen from '../Modules/T&C';
import { domRoutes } from '../PageEnums';
import UIUtils, { utilsRef } from '../ui-components/utils';
import { getMuiTheme } from '../services/Theming';
import NotFoundScreen from '../Modules/Error/NotFoundScreen';
import WidgetingService from '../services/Widgeting';
import allCountriesData from '../utils/country-code-mapping';
import PublicRoute from './PublicRoute';

const customRoutes = [
    '/id/homes/tnc',
    '/id/3c',
    '/in/tnc',
    '/id/tnc',
    '/my/tnc',
    '/ph/tnc',
    '/vn/tnc',
    '/th/tnc'
];

const theme = getMuiTheme();

const App = () => <MuiThemeProvider theme={theme}>
    <div>
        <WidgetingService />
        <UIUtils ref={utilsRef} />
        <Switch>
    
            <PublicRoute exact path="/" component={LandingNew} />
            <PublicRoute exact path="/login" component={LandingNew} />
            {Object.keys(allCountriesData).map(cc => <PublicRoute exact path={'/'+cc} component={LandingNew} />)}
            {Object.keys(allCountriesData).map(cc => <PublicRoute exact path={'/'+cc+'/login'} component={LandingNew} />)}
            
            {customRoutes.map(route => <PublicRoute exact path={route} component={TnCScreen} />)}
            {customRoutes.map(route => <PublicRoute exact path={route + "/*"} component={TnCScreen} />)}
            
            {domRoutes}
    
            {Object.keys(allCountriesData).map(cc => <PublicRoute exact path={'/'+cc + '/*'} component={LandingNew} />)}
            
            <PublicRoute exact path="/tnc" component={TnCScreen} />
            <PublicRoute exact path="/tnc/*" component={TnCScreen} />
            <PublicRoute exact path="/*" component={NotFoundScreen} />
        </Switch>
    </div>
</MuiThemeProvider>;


export default App;
